import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from 'i18next-browser-languagedetector';


import en_US from '#/locales/en-US.json';
import es_CO from '#/locales/es-CO.json';
import pt_BR from '#/locales/pt-BR.json';

const resources = {
  en: {
    translation: en_US
  },
  es: {
    translation: es_CO
  },
  pt: {
    translation: pt_BR
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: localStorage.getItem('language'),
    fallbackLng: "pt",
    keySeparator: false,
    interpolation: {
      escapeValue: false
    },
    detection: {
      lookupQuerystring: 'language'
    }
  });

  export default i18n;